import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rose-echart" }

import { computed } from 'vue'
import BaseEchart from '@/base-ui/echart'

import { IDataType } from '../types'


export default _defineComponent({
  props: {
    roseData: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
  roseData: IDataType[]
}) {

const props = __props


const options = computed(() => {
  return {
    // legend: {
    //   top: 'bottom'
    // },
    toolbox: {
      show: true,
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    series: [
      {
        name: '类别数据',
        type: 'pie',
        radius: [10, 100],
        center: ['50%', '50%'],
        roseType: 'area',
        itemStyle: {
          borderRadius: 8
        },
        data: props.roseData
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseEchart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})